const defaultConcreteClass = {
    name: 'C30/37',
    fck: 30,
    fctm: 2.9,
    fctk: 2,
    ecm: 32837
};

export default defaultConcreteClass;